module.exports = __webpack_public_path__ + "assets/img/index-partner8.da4c4061.jpg";